import React from "react";

import ChevronLeft from "@uui/ChevronLeft";
import ChevronRight from "@uui/ChevronRight";

import Box from "@mui/material/Box";
import Collapse, { CollapseProps } from "@mui/material/Collapse";
import styled from "@mui/material/styles/styled";

import Stack, { StackProps } from "@rui/Stack";

type SidebarCollapseProps = CollapseProps & {
  backgroundColor?: React.CSSProperties["backgroundColor"];
};

export const SidebarCollapse = styled<React.FC<SidebarCollapseProps>>(
  ({ backgroundColor: _bc, ...props }) => <Collapse {...props} />
)(({ backgroundColor, theme }) => ({
  backgroundColor: backgroundColor ?? "#FFF",
  width: "100%",
  [theme.breakpoints.up("md")]: {
    borderLeft: "2px solid",
    borderColor: theme.palette.shades.neutral[100],
    backgroundColor: backgroundColor ?? theme.palette.shades.ghost[300],
  },

  "&.MuiCollapse-entered .sidebar-button-container": {
    opacity: 0,
  },

  "&:hover": {
    ".sidebar-button-container": { opacity: 1 },
  },
  "& .MuiCollapse-wrapperInner": {
    width: "100%",
  },
}));

export const SidebarContent = styled(Stack)(({ theme }) => ({
  minWidth: "100%",
  maxWidth: "100%",
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(2, 2, 0),
    minWidth: "400px",
    maxWidth: "400px",
  },
  [theme.breakpoints.up("lg")]: {
    minWidth: "600px",
    maxWidth: "600px",
  },
  height: "100%",
  maxHeight: "100%",
  overflow: "hidden",
}));

const SidebarButtonContainer = styled(Box)({
  position: "absolute",
  top: 130,
  left: -14,
  transition: "opacity 0.2s ease",
  zIndex: 4,
});

const SidebarButton = styled<React.FC<StackProps>>((props) => (
  <Stack variant="center" {...props} />
))(({ theme }) => ({
  height: "28px",
  width: "28px",
  backgroundColor: "#FFF",
  border: `2px solid ${theme.palette.shades.neutral[200]}`,
  borderRadius: "50%",
  transition: "all 0.1s ease",
  [theme.breakpoints.down("md")]: {
    display: "none",
  },

  "& svg": {
    height: "18px",
    width: "18px",
    color: theme.palette.shades.neutral[200],
  },

  "&:hover": {
    cursor: "pointer",
    backgroundColor: theme.palette.shades.ghost[300],
    boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.1)",
    borderColor: theme.palette.shades.primary[500],

    "& svg": {
      color: theme.palette.shades.primary[500],
    },
  },
}));

type SidebarToggleButtonProps = StackProps & { expanded: boolean };

export const SidebarToggleButton = ({
  expanded,
  ...props
}: SidebarToggleButtonProps) => (
  <SidebarButtonContainer {...props} className="sidebar-button-container">
    <SidebarButton>
      {expanded ? <ChevronRight /> : <ChevronLeft />}
    </SidebarButton>
  </SidebarButtonContainer>
);
